/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from '@artsy/fresnel'
import PropTypes from 'prop-types'
import React, {  useState, useEffect } from 'react'
import { InView } from 'react-intersection-observer'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Tab,
  Message,
} from 'semantic-ui-react'
import conf from './conf'

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
})

const HomepageHeading = ({ mobile, available, logIn }) => {
  return (
    <Container text>
      <Image alt="logo" style={{ marginTop: '6em', marginBottom: '6em' }} src='/images/title-logo-1080x280.png' centered />
      <Header
        as='h1'
        style={{
          fontSize: mobile ? '2em' : '4em',
          fontWeight: 'normal',
          marginTop: mobile ? '0' : '0',
        }}
      >
        <span style={{color: 'purple'}}>Hypno-coaching AI</span>
      </Header>
      <Header
        as='h2'
        style={{
          fontSize: mobile ? '1.1em' : '2.2em',
          fontWeight: 'normal',
          marginTop: mobile ? '0.25em' : '0.5em',
          marginBottom: '2em',
        }}
      >
        <span style={{color: 'dimgray'}}>Harness the Power of Your Conscious and Wisdom of Your Unconscious Mind</span>
      </Header>
      <Button
        style={{
          marginBottom: '5em',
        }}
        color='purple' size='huge' onClick={() => logIn(false)}
      >
        { available ? 'Get Started' : 'Join a Whitelist' }
        <Icon name='right arrow' />
      </Button>
    </Container>
  )
}

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
  available: PropTypes.bool.isRequired,
  logIn: PropTypes.func.isRequired,
}

const DesktopContainer = ({ children, available, logIn }) => {
  const [ fixed, setFixed ] = useState(false)

  return (
    <Media greaterThan='mobile'>
      <InView onChange={(inView) => setFixed(!inView)}>
        <Segment
          textAlign='center'
          style={{ minHeight: 700, padding: '1em 0em' }}
        >
          <Menu
            fixed={fixed ? 'top' : null}
            pointing={!fixed}
            secondary={!fixed}
            size='large'
          >
            <Container>
              <Menu.Item active>
                <Image avatar alt="logo" src='/images/logo192.png' />
                <Link to='/'> {' '} Home</Link>
              </Menu.Item>
              <Menu.Item position='right'>
                { available ? (
                  <>
                    <Button as='a' onClick={() => logIn(true)} >
                      Log In
                    </Button>
                    <Button as='a' primary={fixed} style={{ marginLeft: '0.5em' }} onClick={() => logIn(false)} >
                      Sign up
                    </Button>
                  </>
                ) : (
                  <Button onClick={logIn}>
                    Join a Whitelist
                  </Button>
                )}
              </Menu.Item>
            </Container>
          </Menu>
          <HomepageHeading available={available} logIn={logIn}/>
        </Segment>
      </InView>

      {children}
    </Media>
  )
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
  available: PropTypes.bool.isRequired,
  logIn: PropTypes.func.isRequired,
}

const MobileContainer = ({ children, available, logIn }) => {
  const [ sidebarOpened, setSidebarOpened ] = useState(false)

  return (
    <Media as={Sidebar.Pushable} at='mobile'>
      <Sidebar.Pushable>
        <Sidebar
          as={Menu}
          animation='overlay'
          onHide={() => setSidebarOpened(false)}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item active>
            <Link to='/'>Home</Link>
          </Menu.Item>
          { available ? (
            <>
              <Menu.Item as='a' onClick={() => logIn(true)}>
                Log In
              </Menu.Item>
              <Menu.Item as='a' onClick={() => logIn(false)}>
                Sign up
              </Menu.Item>
            </>
          ) : (
            <Menu.Item onClick={() => logIn(false)}>
              { available ? 'Get Started' : 'Join a Whitelist' }
            </Menu.Item>
          )}
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            textAlign='center'
            style={{ minHeight: 350, padding: '1em 0em' }}
            vertical
          >
            <Container>
              <Menu pointing secondary size='large'>
                <Menu.Item onClick={() => setSidebarOpened(true)}>
                  <Icon name='sidebar' />
                </Menu.Item>
                <Menu.Item position='right'>
                  { available ? (
                    <>
                      <Button as='a' onClick={() => logIn(true)}>
                        { available ? 'Log In' : 'Join a Whilelist' }
                      </Button>
                      <Button as='a' style={{ marginLeft: '0.5em' }} onClick={() => logIn(false)}>
                        { available ? 'Sign up': 'Join a Whitelist' }
                      </Button>
                    </>
                  ) : (
                    <Button onClick={logIn}>
                      Join a Whitelist
                    </Button>
                  ) }
                </Menu.Item>
              </Menu>
            </Container>
            <HomepageHeading mobile available={available} logIn={logIn}/>
          </Segment>

          {children}
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Media>
  )
}

MobileContainer.propTypes = {
  children: PropTypes.node,
  available: PropTypes.bool.isRequired,
  logIn: PropTypes.func.isRequired,
}

const ResponsiveContainer = ({ children, available, logIn }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer available={available} logIn={logIn}>{children}</DesktopContainer>
    <MobileContainer available={available} logIn={logIn}>{children}</MobileContainer>
  </MediaContextProvider>
)

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
  available: PropTypes.bool,
  logIn: PropTypes.func,
}

const HomepageLayout = () => {
  const navigate = useNavigate()
  const [available, setAvailable] = useState(true)

  const logIn = (openLogin) => {
    if (available) {
      // navigate('/chat')
      if (openLogin) {
        navigate('/login')
      } else {
        navigate('/signup')
      }
    } else {
      console.log('navigate to interestForm')
      window.open(conf.interestForm.url, '_blank')
    }
  }

  useEffect(() => {
    // Run only once
    axios.get(`${conf.api.url}/available`)
      .then((response) => {
        if (response.data.status === 'available') {
          console.log('The API is available. You can log in.')
        } else {
          console.warn('Unknown availability status. Join a Whitelist.')
          setAvailable(false)
        }
      })
      .catch(function (error) {
        console.error('error:', error);
        console.warn('The API is unavailable. Join a Whitelist.')
        setAvailable(false)
      })
  }, []);

  return (
    <ResponsiveContainer logIn={logIn} available={available}>

      <Segment style={{ padding: '8em 0em' }} vertical>
        <Grid container stackable verticalAlign='middle'>
          <Grid.Row>
            <Grid.Column floated='left' width={8}>
              <Header as='h3' style={{ fontSize: '2em' }}>
                Achieve your goals faster and more easily with the help of our hypno-coaching web app.
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                Our hypno-coaching web app is a powerful tool that can help you achieve your goals faster and more easily than ever before. It uses the power of your conscious and unconscious mind to help you overcome limiting beliefs, boost your confidence, improve your relationships, achieve your career goals, lose weight, and live a healthier and happier life.
              </p>
              <p style={{ fontSize: '1.33em' }}>
                Our app is easy to use and can be accessed from anywhere in the world. Simply create an account and choose a hypno-coaching program that is right for you.
              </p>

              <Header as='h3' style={{ fontSize: '2em' }}>
                Here are just a few of the benefits of using our hypno-coaching web app:
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                <ul>
                  <li>
                    Overcome limiting beliefs and fears
                  </li>
                  <li>
                    Boost your confidence and self-esteem
                  </li>
                  <li>
                    Improve your relationships
                  </li>
                  <li>
                    Achieve your career goals
                  </li>
                  <li>
                    Lose weight and get in shape
                  </li>
                  <li>
                    Live a healthier and happier life
                  </li>
                </ul>
              </p>

              <Header as='h3' style={{ fontSize: '2em' }}>
                How it works:
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                Hypno-coaching works by helping you to access your subconscious mind. The subconscious mind is responsible for your habits, emotions, and behaviors. By accessing the subconscious mind, you can make positive changes in your life that are lasting.
              </p>
              <p style={{ fontSize: '1.33em' }}>
                Our hypno-coaching web app uses a variety of techniques to help you access your subconscious mind, such as guided imagery, affirmations, and hypnotic suggestions.
              </p>
            </Grid.Column>
            <Grid.Column floated='right' width={6}>
              <Image bordered rounded size='large' src='/images/hypnosis-1.png' />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column floated='left' width={6}>
              <Image bordered rounded size='large' src='/images/coaching-1.png' />
            </Grid.Column>
            <Grid.Column floated='right' width={8}>
              <Header as='h3' style={{ fontSize: '2em' }}>
                What to expect during a session:
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                When you use our hypno-coaching web app, you will listen to a guided audio recording. The recording will guide you into a state of relaxation and help you to focus your attention on your desired outcome.
              </p>

              <Header as='h3' style={{ fontSize: '2em' }}>
                The benefits of hypno-coaching:
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                Hypno-coaching has been shown to be effective for a variety of issues, including:
                <ul>
                  <li>
                    Anxiety
                  </li>
                  <li>
                    Depression
                  </li>
                  <li>
                    Weight loss
                  </li>
                  <li>
                    Smoking cessation
                  </li>
                  <li>
                    Improved sleep
                  </li>
                  <li>
                    Increased self-confidence
                  </li>
                  <li>
                    Improved relationships
                  </li>
                  <li>
                    Common questions about hypno-coaching:
                  </li>
                </ul>
              </p>

              <Header as='h3' style={{ fontSize: '2em' }}>
                The benefits of hypno-coaching:
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                <ul>
                  <li>
                    <b>Is hypno-coaching safe?</b> Yes, hypno-coaching is completely safe. You are always in control during a session and you can wake yourself up at any time.
                  </li>
                  <li>
                    <b>Will I lose control under hypnosis?</b> No, you will not lose control under hypnosis. You are always aware of what is happening and you can choose to accept or reject any suggestions.
                  </li>
                  <li>
                    <b>How long does it take to see results?</b> Most people see results within a few weeks of using hypno-coaching. However, the results vary depending on the individual and the issue being addressed.
                  </li>
                </ul>
              </p>

              <Header as='h3' style={{ fontSize: '2em' }}>
                Guarantee:
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                We're so confident that you'll love our hypno-coaching web app that we offer a 100% satisfaction guarantee. If you're not happy with your results for any reason, simply let us know within 30 days and we'll refund your money.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='center'>
              <Button size='huge' onClick={() => logIn(false)}>
                { available ? 'Get Started' : 'Join a Whitelist' }
                <Icon name='right arrow' />
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>

      <Segment style={{ padding: '0em' }} vertical>
        <Grid celled='internally' columns='equal' stackable>
          <Grid.Row textAlign='center'>
            <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
              <Header as='h4' style={{ fontSize: '1.5em' }}>
                "The Hypno-Coaching AI App has helped me reduce my anxiety, improve my sleep, and lose weight. It's easy to use and the hypnotic suggestions are very effective. I highly recommend it!"
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                <Image avatar src='/images/male.jpeg' />
                - Christopher Rodriguez
              </p>
            </Grid.Column>
            <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
              <Header as='h4' style={{ fontSize: '1.5em' }}>
                "I've been using the Hypno-Coaching AI App for a few weeks now and I'm already seeing a difference in my public speaking skills. I'm less anxious, more confident, and able to focus better. It's a great tool for anyone who wants to improve their public speaking skills."
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                <Image avatar src='/images/female.jpeg' />
                - Laura Garcia
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>

      {/*
      <Container style={{ marginTop: '6em' }}>
        <Divider
          as='h4'
          className='header'
          horizontal
          style={{ margin: '3em 0em', textTransform: 'uppercase' }}
        >
          <a href='#'>
            Demo Video
          </a>
        </Divider>
        <Embed
          id='1FxJ4kelZvw'
          placeholder='/images/demo-placeholder.png'
          source='youtube'
        />
      </Container>
      */}

      <Segment style={{ padding: '3em 0em' }} vertical>
        <Container text>
          <Divider
            as='h4'
            className='header'
            horizontal
            style={{ margin: '3em 0em', textTransform: 'uppercase' }}
          >
            <a href='#'>
              Ready to Laugh?
            </a>
          </Divider>
          <p style={{ fontSize: '1.33em' }}>
            Ready to start your transformation? Sign up for a free to our hypno-coaching app today!
          </p>
          <Button size='large' color='violet' onClick={() => logIn(false)}>
            { available ? 'Get Started Today' : 'Join a Whitelist' }
            <Icon name='right arrow' />
          </Button>
        </Container>
      </Segment>

      <Segment inverted vertical style={{ padding: '5em 0em' }}>
        <Container>
          <Grid divided inverted stackable>
            <Grid.Row>
              <Grid.Column width={3}>
                <Header inverted as='h4' content='About' />
                <List link inverted>
                  <List.Item as='a'>
                    <a href='mailto:admin@vuics.com'>
                      Contact Us
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://www.linkedin.com/showcase/hypno-coaching-ai/' target='_blank' rel='noopener noreferrer'>
                      Follow on LinkedIn
                    </a>
                  </List.Item>
                  {/*
                  <List.Item as='a'>
                    <a href='https://youtube.com/playlist?list=PLXkNXBn6_PqxAFUWetX0_r7825eVMJTAs&si=hdD6MJ1Fo7MSHicc' target='_blank' rel='noopener noreferrer'>
                      Subscribe on YouTube
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://vuics.tawk.help/category/quantum-copilot' target='_blank' rel='noopener noreferrer'>
                      Knowledge Base
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://vuics.tawk.help/article/quantum-copilot-faq' target='_blank' rel='noopener noreferrer'>
                      FAQ
                    </a>
                  </List.Item>
                  */}
                </List>
              </Grid.Column>
              <Grid.Column width={4}>
                <Header inverted as='h4' content='Services' />
                <List link inverted>
                  <List.Item as='a'>
                    <a href='https://qc.vuics.com/' target='_blank' rel='noopener noreferrer'>
                      Quantum Copilot
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://quantum-gpt.vuics.com/' target='_blank' rel='noopener noreferrer'>
                      Quantum GPT
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://vuics.com' target='_blank' rel='noopener noreferrer'>
                      Voice User Interfaces
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://cs.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Contract Smarter
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://jf.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Joke Funnier
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://qt.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Quantum Trading Fund
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://hc.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Hypno-Coaching
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://qm.vuics.com' target='_blank' rel='noopener noreferrer'>
                      TchaiQovsky: Quantum Music
                    </a>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={7}>
                <List link inverted>
                  <List.Item as='a'>
                    <p>
                      Empowering people to achieve goals and live best lives.
                    </p>
                  </List.Item>
                  <List.Item as='a'>
                    <p>
                      © 2023 Vuics. All rights reserved.
                    </p>
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    </ResponsiveContainer>
  )
}

export default HomepageLayout
